import { AbilityBuilder, MongoAbility, createMongoAbility } from '@casl/ability';

import { IUser } from 'modules/auth-session';

export enum EPermissionActions {
  MANAGE = 'manage',
  VIEW = 'view',
  BUY = 'buy',
  SELL = 'sell',
  TRANSFER = 'transfer',
}

export enum EPermissionSubjects {
  WALLET = 'wallet',
  WALLET_CREATION = 'wallet_creation',
  NECS = 'necs',
  NECS_TRANSACTION = 'necs_transaction',
  NECS_CERTIFICATE = 'necs_certificate',
  NECS_FORWARD = 'necs_forward',
  NECS_SETTING = 'necs_setting',
  NECS_ACCOUNT = 'necs_account',
  HKNR_ACCOUNT = 'hknr_account',
  GREX_ACCOUNT = 'grex_account',
  NECS_PD = 'necs_pd',
  ALL = 'all',
}

export type AppPermissions = MongoAbility<[EPermissionActions, EPermissionSubjects]>;

export const definePermissionsFor = (user: IUser | null | undefined) => {
  const { can, cannot, build } = new AbilityBuilder<AppPermissions>(createMongoAbility);
  if (!user) {
    return build();
  }
  if (user.hasAdminAccess || user.hasCompanyAdminAccess) {
    can(EPermissionActions.MANAGE, EPermissionSubjects.ALL);
  } else {
    cannot(EPermissionActions.SELL, EPermissionSubjects.WALLET);
    cannot(EPermissionActions.TRANSFER, EPermissionSubjects.WALLET);
    cannot(EPermissionActions.MANAGE, EPermissionSubjects.NECS_ACCOUNT);
    cannot(EPermissionActions.MANAGE, EPermissionSubjects.HKNR_ACCOUNT);
    cannot(EPermissionActions.MANAGE, EPermissionSubjects.GREX_ACCOUNT);
    cannot(EPermissionActions.MANAGE, EPermissionSubjects.WALLET_CREATION);
  }

  return build();
};
